export const version = '0.9.3';
//# sourceMappingURL=version.js.map